// extracted by mini-css-extract-plugin
module.exports = {"checkboxUnchecked":"Checkbox_checkboxUnchecked__1pCWP","icon":"Checkbox_icon__1wk2K","checkboxChecked":"Checkbox_checkboxChecked__2C1Zv"};